'use strict';

export class EventBus {
	static #listeners = {};

	constructor() {}

	static add(event, listener) {
		if (!this.#listeners[event])
			this.#listeners[event] = [];

		this.#listeners[event].push(listener);
	}

	static remove(event, listener = null) {
		if (!this.#listeners[event])
			return;

		if (listener) {
			// Remove specific listener if provided
			this.#listeners[event] = this.#listeners[event].filter(l => l !== listener);
		} else {
			// Remove all listeners for the given event if no listener is provided
			delete this.#listeners[event];
		}
	}

	static trigger(event, ...args) {
		if (!this.#listeners[event])
			return;

		this.#listeners[event].forEach(listener => listener(...args));
	}
}